/** Available integration types (aligned with BE crmType values) */
export enum IntegrationType {
  PROPSTACK = 'PROPSTACK'
}

/** Integration connection status (FE-derived from BE data) */
export enum IntegrationStatus {
  NOT_CONNECTED = 'NOT_CONNECTED',
  CONNECTED = 'CONNECTED',
  INACTIVE = 'INACTIVE'
}

/** Enriched integration DTO used by UI components */
export interface IntegrationDTO {
  id: string
  type: IntegrationType
  name: string
  description: string
  logoUrl: string
  status: IntegrationStatus
  connectedAt?: string
  /** FE-synthesized Propstack binding: silent provisioning created no BE record, so there are no credentials to disconnect (stopgap until ISSUE-2426) */
  isSyntheticBinding?: boolean
}

/** BE response item from GET /workspace/{workspaceId}/crm-integrations */
export interface CrmIntegrationListItemDTO {
  id: string
  crmType: IntegrationType
  enabled: boolean
}

/** BE response from POST/PATCH credential endpoints */
export interface CrmIntegrationCredentialDTO {
  id: string
  workspaceId: string
  crmType: IntegrationType
  authSchemeType: string
  enabled: boolean
  createdAt: string
  updatedAt: string
}

/** Request body for POST /crm-integrations/credentials/{crmType} */
export interface StoreCrmCredentialsBody {
  authSchemeType: 'API_KEY_HEADER'
  credential: string
}

/** Request body for PATCH /crm-integrations/credentials/{crmType}/enabled */
export interface ToggleCrmEnabledBody {
  enabled: boolean
}

/** Request payload for connecting an integration */
export interface ConnectIntegrationRequest {
  type: IntegrationType
  apiKey: string
  workspaceId: string
}

/** Request payload for disconnecting an integration */
export interface DisconnectIntegrationRequest {
  crmType: IntegrationType
  workspaceId: string
}

/** Request payload for toggling integration status */
export interface ToggleIntegrationStatusRequest {
  crmType: IntegrationType
  enabled: boolean
  workspaceId: string
}
